import script from "./Schemes.vue?vue&type=script&setup=true&lang=js"
export * from "./Schemes.vue?vue&type=script&setup=true&lang=js"

import "./Schemes.vue?vue&type=style&index=0&id=4d3ae792&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3ae792"]])

export default __exports__